import { ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

import { featureConfig } from 'modules/common/featureConfig';
import { DashboardRoutesConfig } from 'modules/dashboard/Routes';
import { DelegateStakingRoutesConfig } from 'modules/delegateStaking/Routes';
import { Account } from 'modules/layout/components/Account';

import logoIcon from '../../assets/logo.svg';
import { Menu } from '../Menu';
import { useStyles } from './useStyles';

interface IHeaderProps {
  className?: string;
}

export function Header({ className }: IHeaderProps): ReactElement {
  const { classes, cx, theme } = useStyles();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));

  const [showMenu, setShowMenu] = useState(false);

  const isFullScreenMenu = isMd && showMenu;

  return (
    <div
      className={cx(
        classes.root,
        isFullScreenMenu && classes.menuRoot,
        className,
      )}
    >
      <header className={cx(classes.header, className)}>
        <Link
          className={classes.logoLink}
          to={
            featureConfig.isDashboardEnabled
              ? DashboardRoutesConfig.dashboard.generatePath()
              : DelegateStakingRoutesConfig.staking.generatePath()
          }
        >
          <img alt="MATSTAKE" className={classes.logo} src={logoIcon} />
        </Link>

        {!isMd && <Menu className={classes.menu} />}

        <Account
          isShowBurger={isMd}
          showMenu={showMenu}
          onShowMenu={setShowMenu}
        />
      </header>

      {isFullScreenMenu && <Menu onClose={() => setShowMenu(false)} />}
    </div>
  );
}
